module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compate-input",
    class: {
      disabled: _vm.disabled
    }
  }, [(_vm.label) ? _c('label', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), (_vm.diff != null) ? _c('span', {
    staticClass: "difference",
    class: _vm.color
  }, [_vm._v(_vm._s(_vm.arrow) + " " + _vm._s(_vm.diff))]) : _vm._e(), _c('span', {
    staticClass: "previous"
  }, [_vm._v("(" + _vm._s(_vm.previous) + ")")])]) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inner_value),
      expression: "inner_value"
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inner_value)
    },
    on: {
      "keydown": _vm.keydown_handler,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inner_value = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e3c330","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/CompareInput.vue
// module id = 303
// module chunks = 0